var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoldCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94641 11.64C10.2712 11.8363 10.6939 11.7296 10.8832 11.4048C11.8856 9.68507 13.6363 6.68133 14.803 4.67962C15.3256 3.78306 16.6437 3.78306 17.1662 4.67962C18.3329 6.68133 20.0837 9.68507 21.0861 11.4048C21.2754 11.7296 21.6981 11.8363 22.0229 11.64C23.7425 10.6006 25.7012 9.30884 27.1959 8.30084C28.1501 7.65732 29.442 8.38234 29.3261 9.51212C28.941 13.2679 28.1559 19.9131 27.0412 24.3871C26.8843 25.017 26.5131 25.5581 25.8848 25.761C24.6744 26.152 21.9429 26.6739 15.9846 26.6739C10.1713 26.6739 7.42965 26.1771 6.17548 25.7898C5.48499 25.5765 5.09311 24.9769 4.94305 24.2826C3.8508 19.2284 3.07304 13.086 2.67547 9.54797C2.54796 8.41324 3.84527 7.6752 4.80476 8.322C6.29543 9.32687 8.23883 10.6079 9.94641 11.64Z",
    fill: "#D8B506"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.0072C20 19.0072 17 23.3405 16 23.3405C15 23.3405 12 19.0072 12 18.0072C12 17.0072 15 12.6739 16 12.6739C17 12.6739 20 17.0072 20 18.0072Z",
    fill: "#FCEEA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldCrown);
export default __webpack_public_path__ + "static/media/goldCrown.a21311be5a6cee31b0b2984d7683dc76.svg";
export { ForwardRef as ReactComponent };